var text_field_default = {
  "root": "w0BM9",
  "text": "KdARE",
  "input": "moZ0r",
  "small": "Sk0ao",
  "medium": "-XGmq",
  "large": "iOIgW",
  "webview": "lKaAY",
  "endAdornment": "prrlo",
  "shown": "tibEm",
  "value": "SfOO5",
  "spinner": "C8G2N",
  "spin": "igfCn"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
